import { Reducer } from 'redux';
import deepmerge from 'deepmerge';
import { IFinanceDocumentState, DocActionTypes } from './types';
import { StudentActionTypes } from '../types';
import { DataActionTypes } from '../../data/types';
import { transformObject } from '../documents/helpers';
import { IAnyObj } from '../../../types';
import { getDocDetails } from '../../../utilities/documents';

const initialState: IFinanceDocumentState = {
  evidenceOfIncome: {},
  deposit: {},
  birthCertificate: {},
  familySponsorship: {},
  governmentSponsorship: {},
  companySponsorship: {},
  scholarshipSponsorship: {},
  educationSponsorship: {},
  other: {},
  customRequest: {},
  customDocuments: {}, // TODO: added as I needed latest @types but latest Uni changes not merged
  documentsRequired: 0,
  documentsComplete: 0,
  agentDocumentsRequired: 0,
  agentDocumentsComplete: 0,
  isSectionStarted: false,
  isSectionComplete: false,
};

const overwriteMerge = (_: [], sourceArray: []) => sourceArray;

const mainReducer: Reducer<IFinanceDocumentState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_FIN_DOCS_SUCCESS: {
      let financeDocuments = transformObject(action.payload.finDocs);

      // BE naming issue evidenceOfIncome => incomeEvidence
      if ('incomeEvidence' in financeDocuments) {
        financeDocuments = {
          ...financeDocuments,
          evidenceOfIncome: {
            ...(financeDocuments as any).incomeEvidence,
          },
        };
        delete (financeDocuments as any).incomeEvidence;
      }
      return {
        ...initialState,
        ...financeDocuments,
      };
    }
    case StudentActionTypes.SAVE_FINANCE_DOCUMENTS_SUCCESS:
    case DocActionTypes.TOGGLE_DOC_SUCCESS: {
      const finDocs = transformObject(action.payload.finDocs);

      // merge the delta
      const newState = deepmerge(state, finDocs, {
        arrayMerge: overwriteMerge,
      });
      return {
        ...newState,
      };
    }
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_FINANCE_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
    case StudentActionTypes.DELETE_DOCUMENT_FILE_SUCCESS:
    case StudentActionTypes.UPDATE_CONFLICT_SUCCESS:
    case StudentActionTypes.UPDATE_OFFER_EVIDENCE_SUCCESS: {
      if (action.payload.financeDocuments) {
        return {
          ...state,
          ...action.payload.financeDocuments,
        };
      }
      return state;
    }
    case StudentActionTypes.UPDATE_FINANCE_DOCUMENTS: {
      if (action.payload?.finDocs) {
        const newState = deepmerge(state, action.payload.finDocs, {
          arrayMerge: overwriteMerge,
        });
        return {
          ...newState,
        };
      }
      return state;
    }

    case StudentActionTypes.DELETE_FINANCE_FILE_SUCCESS: {
      if (action.payload?.financeDocuments) {
        const finDocs = transformObject(action.payload.financeDocuments);

        // merge the delta
        const newState = deepmerge(state, finDocs, {
          arrayMerge: overwriteMerge,
        });
        return {
          ...newState,
        };
      }
      return state;
    }

    case StudentActionTypes.DELETE_FILE: {
      const { sponsorType, sponsorKey, docType, docKey, fileNames, isFinanceDocumentModal } = action.payload;

      if (!isFinanceDocumentModal) {
        return state;
      }
      const newState = { ...state };
      const newRecord = getDocDetails({ docs: newState, sponsorType, sponsorKey, docType, docKey }) as IAnyObj;
      newRecord.fileNames = fileNames;

      return {
        ...newState,
      };
    }

    case DataActionTypes.UPLOAD_FILE_SUCCESS: {
      const { sponsorType, sponsorKey, docType, docKey, fileNames, isFinanceDocumentModal } = action.payload;

      if (!isFinanceDocumentModal) {
        return state;
      }
      // TODO -for student if hasErrors
      // has errors ?
      const status = 'UPLOADED_OK';
      const newState = { ...state };
      const newRecord = getDocDetails({ docs: newState, sponsorType, sponsorKey, docType, docKey }) as IAnyObj;

      // strip out file upload failures
      let parsedFileNames: string[] = fileNames;
      parsedFileNames = fileNames?.filter((fName: string) => !fName.includes('upload--error--')) ?? [];
      newRecord.fileNames = parsedFileNames;

      newRecord.status = status;

      return {
        ...newState,
      };
    }

    default:
      return state;
  }
};

export { mainReducer as financeDocumentsReducer };
